import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./app.api"; // Axios API slice// Supabase API slice
import { supabaseApi } from "./supabaseApi";

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    [supabaseApi.reducerPath]: supabaseApi.reducer, // ✅ Add Supabase slice
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: {
        extraArgument: apiSlice, // ✅ Keep your thunk config
      },
      serializableCheck: false,
    })
      .concat(apiSlice.middleware)
      .concat(supabaseApi.middleware), // ✅ Add Supabase middleware
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
